import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(() => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)), []);

  useEffect(() => {
    check();
    const out = () => setUser(false);
    window.addEventListener("hcs-logout", out);
    return () => window.removeEventListener("hcs-logout", out);
  }, [check]);

  useEffect(() => {
    if (!user) return undefined;
    const t = setInterval(() => api.post("/auth/refresh").catch(() => setUser(false)), 10 * 60 * 1000);
    return () => clearInterval(t);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, logout, check }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-10 text-center text-slate-500" data-testid="auth-loading">Checking your session…</div>;
  if (!user) return <Navigate to="/dealer/login" replace state={{ from: loc.pathname }} />;
  return children;
}
